<svelte:options runes={false} />

<script>
  export let payerUrl;
  export let onCopyLink;
  export let onShareLink;
</script>

<section class="share-panel" aria-label="Share invoice">
  <label>
    Payer link
    <input readonly value={payerUrl} on:focus={(event) => event.currentTarget.select()} />
  </label>
  <div class="button-row">
    <button class="primary" type="button" on:click={onCopyLink}>Copy link</button>
    {#if navigator.share}
      <button type="button" on:click={onShareLink}>Share…</button>
    {/if}
  </div>
</section>
